import { ApplicationWorkflowTranslator } from 'src/translators'
import { ApplicationWorkflowFormEntity } from 'src/types'
import {
  useCancelSelectAgreementMutation,
  useCreateApplicationMutation,
  useExcludeRoomsFromPublishApplicationMutation,
  useExcludeRoomsFromOrderApplicationMutation,
} from 'src/types/generated'

type CreateInput = {
  workflowId: number
  projectId: string
  targetRoomIds: string[]
  formEntity: ApplicationWorkflowFormEntity
  workflowType: 'publish' | 'order'
}

type CancelSelectAgreementInput = {
  projectId: string
  roomIds: string[]
}

type ExcludeRoomsFromPublishApplicationInput = {
  projectId: string
  roomIds: string[]
  comment?: string
}

type ExcludeRoomsFromOrderApplicationInput = {
  projectId: string
  roomIds: string[]
  comment?: string
}

export const useApplication = () => {
  const [createApplicationMutation] = useCreateApplicationMutation()
  const [cancelSelectAgreementMutation] = useCancelSelectAgreementMutation()
  const [excludeRoomsFromPublishApplicationMutation] =
    useExcludeRoomsFromPublishApplicationMutation()
  const [excludeRoomsFromOrderApplicationMutation] = useExcludeRoomsFromOrderApplicationMutation()

  const createApplication = async (input: CreateInput): Promise<{ appliedRoomIds: number[] }> => {
    const params = ApplicationWorkflowTranslator.toRequest(input)
    const { data } = await createApplicationMutation({ variables: { input: params } })
    return { appliedRoomIds: data?.createApplication.appliedRoomIds ?? [] }
  }

  const cancelSelectAgreement = async (input: CancelSelectAgreementInput): Promise<void> => {
    const { projectId, roomIds } = input
    await cancelSelectAgreementMutation({
      variables: { projectId, params: { roomIds: roomIds.map(Number) } },
    })
  }

  const excludeRoomsFromPublishApplication = async (
    input: ExcludeRoomsFromPublishApplicationInput
  ): Promise<void> => {
    const { projectId, roomIds, comment } = input
    await excludeRoomsFromPublishApplicationMutation({
      variables: {
        projectId,
        params: {
          roomIds: roomIds.map(Number),
          comment,
        },
      },
    })
  }

  const excludeRoomsFromOrderApplication = async (
    input: ExcludeRoomsFromOrderApplicationInput
  ): Promise<void> => {
    const { projectId, roomIds, comment } = input
    await excludeRoomsFromOrderApplicationMutation({
      variables: {
        projectId,
        params: {
          roomIds: roomIds.map(Number),
          comment,
        },
      },
    })
  }

  return {
    createApplication,
    cancelSelectAgreement,
    excludeRoomsFromPublishApplication,
    excludeRoomsFromOrderApplication,
  }
}
